/*
 * @Author: zhuyan 
 * @Date: 2021-4-27 10:38:14 
 * 模块名称: 已支付-公司内部往来款
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import InternalAccount from './InternalAccount'
import PaymentLog from './PaymentLog'

const InternalAccountIndex = ({ match, history }) => {
  return (
    <Switch>
      <Route path={match.path + '/paymentlog'} component={PaymentLog} />
      <Route component={InternalAccount} />
    </Switch>
  )
}

export default InternalAccountIndex